<template>
<v-layout column>
    <v-card>
        <v-toolbar :color="(item.BugCount != null && item.BugCount !== '') || (item.Notes != null && item.Notes !== '') ? 'primary' : 'warning'" class="white--text">
            <v-toolbar-title>{{ item.TrapModel.TrapIdentifier }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon large dark>bug_report</v-icon>
        </v-toolbar>
    </v-card>
    <v-card>
        <v-layout row wrap pa-2>
            <v-flex>
                <label-value :label="'Type'" :value="item.TrapModel.TrapType"></label-value>
            </v-flex>
            <v-flex>
                <label-value :label="'Zone'" :value="item.TrapModel.TrapZoneName"></label-value>
            </v-flex>
            <v-flex>
                <label-value :label="'Placed'" :value="item.TrapModel.DatePlaced | formatDate"></label-value>
            </v-flex>
        </v-layout>
        <v-layout column pa-2>
            <v-flex>
                <v-text-field box clearable v-model='item.BugCount' type="number" :rules="[rules.From0To100, rules.integerOnly]" label="Count"></v-text-field>
            </v-flex>
            <v-flex>
                <v-textarea box clearable name="notes" label="Trap Notes" counter="1000" :rules="[rules.maxOneThousandCharacters]" v-model="item.Notes" hint="Trap Notes"></v-textarea>
            </v-flex>
        </v-layout>
        <v-layout row wrap pa-2>
            <v-flex v-if="geoEnalbed" xs1>
                <v-btn fab small color="info" @click="getLocation">
                    <v-icon large>location_on</v-icon>
                </v-btn>
            </v-flex>
            <v-flex xs5 offset-xs1 pr-1>
                <v-text-field box clearable v-model='item.Latitude' type="number" label="Latitude"></v-text-field>
            </v-flex>
            <v-flex xs5>
                <v-text-field box clearable v-model='item.Longitude' type="number" label="Longitude"></v-text-field>
            </v-flex>
        </v-layout>
    </v-card>
</v-layout>
</template>

<script>
import LabelValue from '@/components/generic/LabelValue.vue';
import validationRules from "@/helpers/validationrules";

export default {
    components: {
        LabelValue
    },
    props: [
        'item'
    ],
    data() {
        return {
            rules: validationRules.rules
        }
    },
    computed: {
        geoEnalbed() {
            return "geolocation" in navigator
        }
    },
    methods: {
        getLocation() {
            let _this = this;
            navigator.geolocation.getCurrentPosition(pos => {
                _this.$set(_this.item, "Latitude", pos.coords.latitude);
                _this.$set(_this.item, "Longitude", pos.coords.longitude);
            }, err => {                
                console.log("Error Getting Location", err);
            });
        }
    }
}
</script>
